module.exports = __webpack_public_path__ + "static/media/Software.07249dbc.png";